import "../scss/style.scss"

import "../js/animation.js"
import "../js/modal.js"